var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaint = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.179,
    height: 26.721,
    viewBox: "0 0 25.179 26.721",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5484",
    "data-name": "Caminho 5484",
    d: "M178.431,119.352c4.373,3.668,5.078,10.156-4.514,13.683-2.4.705-3.1,3.95-2.4,7.053.423,2.821-6.63,5.5-11.849-.705a11.541,11.541,0,0,1-2.962-5.642c-2.962-13.4,12.272-22.147,21.724-14.388Zm-4.373,4.937a1.464,1.464,0,0,1,1.834,1.128,1.743,1.743,0,0,1-1.27,1.975,1.594,1.594,0,0,1-1.834-1.27,1.417,1.417,0,0,1,1.27-1.834Zm-3.385-5.925a1.537,1.537,0,0,1,1.834,1.128,1.362,1.362,0,0,1-1.128,1.834,1.411,1.411,0,0,1-1.834-1.128A1.711,1.711,0,0,1,170.673,118.364Zm-5.219,1.552a1.44,1.44,0,0,1,1.834,1.27,1.334,1.334,0,0,1-1.128,1.693,1.573,1.573,0,0,1-1.834-1.128,1.619,1.619,0,0,1,1.128-1.834Zm-3.809,3.527a1.619,1.619,0,0,1,1.834,1.128,1.523,1.523,0,0,1-2.962.705A1.619,1.619,0,0,1,161.645,123.442Zm-1.128,5.36a1.464,1.464,0,0,1,1.834,1.128,1.411,1.411,0,0,1-1.128,1.834,1.889,1.889,0,0,1-1.975-1.128,1.716,1.716,0,0,1,1.27-1.834Z",
    transform: "translate(-156.332 -116.439)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paint.287ca505a40aa9f0b5612fef8a9dfe82.svg";